import Snippets from "./Snippets";

const GoogleTagManager = {
    // eslint-disable-next-line @typescript-eslint/ban-types
    _gtm: function (id: string): { gtag: Function, script: Function } {
        const snippets = Snippets.tags(id);

        const gtag = () => {
            const gtag = document.createElement("script");
            gtag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
            gtag.async = true;

            return gtag;
        };

        const script = () => {
            const script = document.createElement("script");
            script.innerHTML = snippets.script;

            return script;
        };

        return {
            gtag,
            script
        };

    },

    initialize: function (measurementId: string) {
        const gtm = this._gtm(measurementId);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.head.insertBefore(gtm.gtag(), document.head.childNodes[0]);
    }

};

export default GoogleTagManager;